import { useQuery } from "@tanstack/react-query";

import { authHeader, formsFetch, retryServerErrors, unwrap } from "../lib/formsApi";

import useToken from "./useToken";

export const useAssessments = (type?: "feedback", enabled = true) => {
    const { token } = useToken();
    return useQuery({
        queryKey: ["assessments", type ?? "all"],
        queryFn: async ({ signal }) =>
            unwrap(
                await formsFetch.GET("/api/ast", {
                    params: { query: type ? { type } : undefined },
                    headers: authHeader(token),
                    signal,
                }),
                "list assessments"
            ).assessments,
        enabled,
        retry: retryServerErrors,
    });
};

export const useInvitation = () => {
    const { token } = useToken();
    return useQuery({
        queryKey: ["invitation"],
        queryFn: async ({ signal }) =>
            unwrap(await formsFetch.GET("/api/invitation", { headers: authHeader(token), signal }), "get invitation"),
        retry: retryServerErrors,
    });
};

export const useCampaign = () => {
    const { token } = useToken();
    return useQuery({
        queryKey: ["campaign"],
        queryFn: async ({ signal }) =>
            unwrap(await formsFetch.GET("/api/campaign", { headers: authHeader(token), signal }), "get campaign"),
        retry: retryServerErrors,
    });
};
